import React, { useState } from "react";
import ReportsTab from "../components/analytics/reports/ReportsTab";
import AlertsTab from "../components/analytics/alerts/AlertsTab";

const TABS = {
  REPORTS: "reports",
  ALERTS: "alerts",
};

const Analytics = () => {
  const [activeTab, setActiveTab] = useState(TABS.REPORTS);
  const [paidOnly, setPaidOnly] = useState(false);

  return (
    <div className="space-y-6">
      <div className="rounded-[32px] border border-slate-200 bg-gradient-to-r from-white via-[#f6fbfb] to-[#eef8f7] p-6 shadow-[0_16px_50px_rgba(15,23,42,0.06)]">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#54B0AF]">
              Admin Intelligence
            </p>
            <h1 className="mt-2 text-3xl font-semibold text-slate-900">
              Analytics and Alerts
            </h1>
            <p className="mt-2 max-w-2xl text-sm text-slate-600">
              Review activation, completion, retention, and alert delivery signals in one place.
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-end gap-3">
            <label className="flex min-h-[44px] items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-700 shadow-sm">
              <input
                type="checkbox"
                checked={paidOnly}
                onChange={(e) => setPaidOnly(e.target.checked)}
                className="h-4 w-4 rounded border-slate-300 text-[#54B0AF]"
              />
              <span className="font-medium">Paid users only</span>
            </label>

            <div className="inline-flex rounded-2xl border border-slate-200 bg-white p-1 shadow-sm">
              <TabButton
                active={activeTab === TABS.REPORTS}
                onClick={() => setActiveTab(TABS.REPORTS)}
              >
                Reports
              </TabButton>
              <TabButton
                active={activeTab === TABS.ALERTS}
                onClick={() => setActiveTab(TABS.ALERTS)}
              >
                Alerts
              </TabButton>
            </div>
          </div>
        </div>
      </div>

      {activeTab === TABS.REPORTS ? (
        <ReportsTab paidOnly={paidOnly} />
      ) : (
        <AlertsTab />
      )}
    </div>
  );
};

const TabButton = ({ active, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={`rounded-xl px-4 py-2 text-sm font-medium transition ${
      active
        ? "bg-[#54B0AF] text-white shadow"
        : "bg-transparent text-slate-600"
    }`}
  >
    {children}
  </button>
);

export default Analytics;

